/**
 * 校验非空
 * @param value
 * @returns {boolean}
 */
function isEmpty (value) {
    if (value == null || value === '') {
        return true
    }
    return false
}
function isAllEmpty (...values) {
    for (let value of values) {
        if (value == null || value === '') {
        } else {
            return false
        }
    }
    return false
}
function hasEmpty (...values) {
    for (let value of values) {
        if (value == null || value === '') {
            return true
        }
    }
    return false
}

/**
 * encodeURI 加 序列化  用于页面传参
 * @param value
 * @returns {string}
 */
function encodeURIAndStringify(value) {
    return encodeURIComponent(JSON.stringify(value).replace(/%/g, '%25'));
}
/**
 * decodeURI 加 反序列化  用于页面接受参数
 * @param value
 */
function decodeURIAndParse(value) {
    return JSON.parse(decodeURIComponent(value).replace(/%25/g, '%'));
}
const StringUtils = {
    isEmpty,
    isAllEmpty,
    hasEmpty,
    encodeURIAndStringify,
    decodeURIAndParse
};
export default StringUtils
